var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.0588 22H33.2941V32.3529C33.2941 32.8729 32.8729 33.2941 32.3529 33.2941H22V37.0588C22 37.5788 22.4212 38 22.9412 38H37.0588C37.5788 38 38 37.5788 38 37.0588V22.9412C38 22.4212 37.5788 22 37.0588 22Z",
    fill: "#0F53FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0588 33H17.9412C17.4212 33 17 32.5788 17 32.0588V17.9412C17 17.4212 17.4212 17 17.9412 17H32.0588C32.5788 17 33 17.4212 33 17.9412V32.0588C33 32.5788 32.5788 33 32.0588 33Z",
    fill: "#0F53FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconE);
export default __webpack_public_path__ + "static/media/IconE.37cdfba637d4c746d9c3c1bdf63709ff.svg";
export { ForwardRef as ReactComponent };